import { render, staticRenderFns } from "./InssAlterModal.vue?vue&type=template&id=7c23d755"
import script from "./InssAlterModal.vue?vue&type=script&lang=js"
export * from "./InssAlterModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports